import {
  ApolloError,
  isApolloError as isApolloErrorBase,
} from "@apollo/client";

const isApolloError = (error: unknown): error is ApolloError =>
  isApolloErrorBase(error as Error);

export default isApolloError;
